module.exports = __webpack_public_path__ + "static/media/correct-1.d3fca37d.mp3";